declare global {
  interface Window {
    dataLayer: Record<string, unknown>[]
  }
}

function getSessionId(): string {
  let sid = sessionStorage.getItem('__sid')
  if (!sid) {
    sid = 's_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8)
    sessionStorage.setItem('__sid', sid)
  }
  return sid
}

export function track(event: string, params?: Record<string, string | number>) {
  window.dataLayer = window.dataLayer || []
  const payload = { event, ...params, ts: Date.now() }
  window.dataLayer.push(payload)

  try {
    const body = JSON.stringify({
      event,
      location: params?.location ? String(params.location) : undefined,
      resource: params?.resource ? String(params.resource) : undefined,
      type: params?.type ? String(params.type) : undefined,
      page: typeof window !== 'undefined' ? window.location.pathname : undefined,
      session_id: getSessionId(),
      meta: params || null,
    })
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api-event', new Blob([body], { type: 'application/json' }))
    } else {
      fetch('/api-event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true })
    }
  } catch { /* ignore */ }
}

export function trackPageView() {
  track('page_view', { page: window.location.pathname })
}
